import moment from "moment";

// find aircraft name
export const findAircraft = (arr) => {
  const newArr = [];
  arr?.map((res) => {
    res?.directions?.map((direction) => {
      direction?.map((item) => {
        item?.segments?.map((segment) => {
          if (segment?.details?.length > 0) {
            if (segment?.details[0]?.equipment) {
              newArr.push({
                name: segment?.details[0]?.equipment,
                isClicked: false,
              });
            }
            // newArr.push({
            //   name: segment?.details[0]?.equipment,
            //   isClicked: false,
            // });
          }
        });
      });
    });
  });
  return Array.from(new Set(newArr.map((obj) => obj.name))).map((id) =>
    newArr.find((obj) => obj.name === id)
  );
};

// find layOverAirport name
export const layOverAirportName = (arr) => {
  const newArr = [];
  arr?.map((res) => {
    res?.directions?.map((direction) => {
      direction?.map((item) => {
        item?.segments?.map((segment, index) => {
          if (index === 1) {
            if (segment?.fromAirport) {
              newArr.push({ name: segment?.fromAirport, isClicked: false });
            }
          } else if (index === 2) {
            if (segment?.fromAirport) {
              newArr.push({ name: segment?.fromAirport, isClicked: false });
            }
          } else if (index === 3) {
            if (segment?.fromAirport) {
              newArr.push({ name: segment?.fromAirport, isClicked: false });
            }
            // newArr.push({ name: segment?.fromAirport, isClicked: false });
          }
        });
      });
    });
  });
  return Array.from(new Set(newArr.map((obj) => obj.name))).map((id) =>
    newArr.find((obj) => obj.name === id)
  );
};

// all filter function
export const refunbableFilter = (arr, obj) => {
  if (obj.refunbable && !obj.nonRefundable) {
    const newArr = arr.filter((item) => item.refundable === true);
    return newArr;
  } else if (obj.nonRefundable && !obj.refunbable) {
    const newArr = arr.filter((item) => item.refundable === false);
    return newArr;
  } else {
    return arr;
  }
};

export const scheduleFilter = (airResponseArr, onwordSchduleArr, type) => {
  const newArr = [];
  airResponseArr?.map((res) => {
    res?.directions?.map((direction) => {
      direction?.map((item) => {
        item?.segments?.map((segment) => {
          onwordSchduleArr?.map((schdule) => {
            if (schdule.isClicked) {
              if (type === 0) {
                if (
                  moment(segment?.departure).hour() >= schdule.min &&
                  moment(segment?.departure).hour() < schdule.max
                ) {
                  newArr.push(res);
                }
              } else {
                if (
                  moment(segment?.arrival).hour() >= schdule.min &&
                  moment(segment?.arrival).hour() < schdule.max
                ) {
                  newArr.push(res);
                }
              }
            }
          });
        });
      });
    });
  });
  if (
    newArr.length > 0 ||
    onwordSchduleArr?.some((schdule) => schdule.isClicked === true)
  ) {
    return Array.from(new Set(newArr.map((obj) => obj.itemCodeRef))).map((id) =>
      newArr.find((obj) => obj.itemCodeRef === id)
    );
  } else {
    return airResponseArr;
  }
};

export const scheduleFilterMulti = (airResponseArr, onwordSchduleArr, type) => {
  const filteredArr = [];

  airResponseArr?.forEach((res) => {
    const directions = res?.directions;

    const allMatch = directions?.every((directionList, dirIndex) => {
      const scheduleOptions = onwordSchduleArr?.[dirIndex];

      // If no schedule filters for this direction, skip filtering
      if (!scheduleOptions || !Array.isArray(scheduleOptions)) return true;

      // Get all clicked time filters for current direction
      const activeTimeFilters = scheduleOptions.filter((sch) => sch.isClicked);

      // If no filters clicked for this direction, skip filtering
      if (activeTimeFilters.length === 0) return true;

      // directionList should be an array of flight options
      return directionList?.some((item) => {
        const segment = item?.segments?.[0];
        if (!segment) return false;

        const time =
          type === 0
            ? moment(segment.departure).hour()
            : moment(segment.arrival).hour();

        // Check if the time falls into any active filter range
        return activeTimeFilters.some((filter) => {
          return time >= filter.min && time < filter.max;
        });
      });
    });

    if (allMatch) {
      filteredArr.push(res);
    }
  });

  // Check if any filters are active
  const isAnyClicked = onwordSchduleArr?.some((group) =>
    group?.some((schdule) => schdule.isClicked)
  );

  if (filteredArr.length > 0 || isAnyClicked) {
    // Remove duplicates based on itemCodeRef
    return Array.from(new Set(filteredArr.map((obj) => obj.itemCodeRef))).map(
      (id) => filteredArr.find((obj) => obj.itemCodeRef === id)
    );
  } else {
    // No filter applied, return all
    return airResponseArr;
  }
};

export const layOverAirportFilter = (arr, layOverAirport) => {
  const newArr = [];
  arr?.map((res) => {
    res?.directions?.map((direction) => {
      direction?.map((item) => {
        item?.segments?.map((segment) => {
          layOverAirport?.map((airport) => {
            if (airport.isClicked) {
              if (segment?.fromAirport === airport.name) {
                newArr.push(res);
              }
            }
          });
        });
      });
    });
  });
  if (
    newArr.length > 0 ||
    layOverAirport?.some((schdule) => schdule.isClicked === true)
  ) {
    return Array.from(new Set(newArr.map((obj) => obj.itemCodeRef))).map((id) =>
      newArr.find((obj) => obj.itemCodeRef === id)
    );
  } else {
    return arr;
  }
};

export const aircraftFilter = (arr, aircraft) => {
  const newArr = [];
  arr?.map((res) => {
    res?.directions?.map((direction) => {
      direction?.map((item) => {
        item?.segments?.map((segment) => {
          aircraft?.map((craft) => {
            if (craft.isClicked) {
              if (segment?.details[0]?.equipment === craft.name) {
                newArr.push(res);
              }
            }
          });
        });
      });
    });
  });
  if (
    newArr.length > 0 ||
    aircraft?.some((schdule) => schdule.isClicked === true)
  ) {
    return Array.from(new Set(newArr.map((obj) => obj.itemCodeRef))).map((id) =>
      newArr.find((obj) => obj.itemCodeRef === id)
    );
  } else {
    return arr;
  }
};

export const layoverFilter = (arr, layoverTime) => {
  const newArr = [];
  arr?.map((res) => {
    res?.directions?.map((direction) => {
      direction?.map((item) => {
        item?.segments?.map((segment, indx) => {
          layoverTime?.map((time) => {
            if (time.isClicked) {
              if (item?.segments?.length === 1 && time.min === 0) {
                newArr.push(res);
              } else if (item?.segments[indx + 1]) {
                let arrivalTime = moment(item?.segments[indx]?.arrival);
                let departureTime = moment(item?.segments[indx + 1]?.departure);
                let diff = moment.duration(departureTime?.diff(arrivalTime));
                let timeDiffHours = parseInt(diff.asHours());
                if (timeDiffHours >= time.min && timeDiffHours < time.max) {
                  newArr.push(res);
                }
              }
            }
          });
        });
      });
    });
  });
  if (
    newArr.length > 0 ||
    layoverTime?.some((schdule) => schdule.isClicked === true)
  ) {
    return Array.from(new Set(newArr.map((obj) => obj.itemCodeRef))).map((id) =>
      newArr.find((obj) => obj.itemCodeRef === id)
    );
  } else {
    return arr;
  }
};

export const airlinesCodeName = (item) => {
  const newArr = [];
  item?.segments?.map((segment) => {
    newArr?.push({
      airlineCode: segment.airlineCode,
      airline: segment.airline,
      flightNumber: segment.flightNumber,
      equipment: segment?.details[0].equipment,
    });
  });

  return Array.from(new Set(newArr.map((obj) => obj.airlineCode))).map((id) =>
    newArr.find((obj) => obj.airlineCode === id)
  );
};

export const fareTypeFilter = (airResponseArr, obj) => {
  const newArr = [];
  airResponseArr?.map((res) => {
    obj?.map((item) => {
      if (
        item.isClicked &&
        (item.value === res?.passengerFares?.adt?.fareType ||
          item.value === res?.passengerFares)
      ) {
        newArr.push(res);
      }
    });
  });
  if (newArr.length > 0) {
    return Array.from(new Set(newArr.map((obj) => obj.itemCodeRef))).map((id) =>
      newArr.find((obj) => obj.itemCodeRef === id)
    );
  } else {
    if (obj?.some((item) => item.isClicked === true)) {
      return [];
    } else {
      return airResponseArr;
    }
  }
};
